<template>
  <div class="speaker-line">
    <img class="palestrante__img" :src="getImage" alt />
    <div class="palestrante__desc">
      <span v-if="coordinator" class="coordinator-label">
        <span v-if="$route.params.language === 'pt'">Coordenador</span>
        <span v-else>Coordinator</span>
      </span>
      <span v-if="mediator" class="mediator-label">
        <span v-if="$route.params.language === 'pt'">Moderador</span>
        <span v-else>Moderator</span>
      </span>
      <strong class="name__speaker">{{ speaker.name }}</strong>
      <small class="name__job">
        <span v-if="$route.params.language === 'pt'">
          <em>{{ speaker.job_title_pt }} @ {{ speaker.company.company_pt }}</em>
        </span>
        <span v-if="$route.params.language === 'en'">
          <em>{{ speaker.job_title_en }} @ {{ speaker.company.company_en }}</em>
        </span>
        <span v-if="$route.params.language === 'es'">
          <em>{{ speaker.job_title_es }} @ {{ speaker.company.company_es }}</em>
        </span>
      </small>
    </div>
    <p class="speaker-about">{{ speakerAbout }}</p>
  </div>
</template>

<script>
export default {
  name: "Speaker",
  props: ["speaker", "coordinator", "mediator"],
  data() {
    return {
      over: false
    };
  },
  computed: {
    speakerAbout() {
      if (this.$route.params.language === "en") {
        return this.speaker.curriculum_en;
      }

      if (this.$route.params.language === "es") {
        return this.speaker.curriculum_es;
      }

      return this.speaker.curriculum_pt;
    },
    getImage() {
      const imgUrl =
        "https://px3-static.sfo2.cdn.digitaloceanspaces.com/futurecom19/";
      // const ext = ".png";
      if (this.speaker.photo) {
        return imgUrl + this.speaker.photo;
      }
      return null;
    }
  },
  methods: {
    mouseOver() {
      this.over = true;
    },
    mouseLeave() {
      setTimeout(() => {
        this.over = false;
      }, 100);
    }
  }
};
</script>

<style lang="scss" scoped>
.coordinator-label {
  font-size: 8pt;
  background: #1d8efb;
  border-radius: 4px;
  overflow: hidden;
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  padding: 1px;
}
.mediator-label {
  font-size: 8pt;
  background: #28a745;
  border-radius: 4px;
  overflow: hidden;
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  padding: 1px;
}
.speaker-line {
  width: 100%;
  display: block;
  margin: 0 0 10px;
  border-bottom: solid 1px #cacdd0;
  strong {
    width: 100%;
    display: inline-block;
  }
  .speaker-about {
    font-size: 8pt;
  }
}
.avatar {
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50px;
}
.highlight {
  border: solid 1px #01273a;
}
.avatar2 {
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 50px;
  background: rgb(199, 199, 199);
  margin: 0 auto;
  display: block;
}
.speaker {
  float: right;
  margin-right: 5px;
  cursor: pointer;
}
.speaker-info {
  font-size: 10pt;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}
.fade-enter {
  transition-delay: 0.75s;
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
.palestrante__img {
  display: none;
}
.col-12 {
  .speaker-line {
    .palestrante__img {
      max-width: 40px;
      display: inline-block;
    }
    .palestrante__desc {
      display: inline-block;
      max-width: 290px;
      line-height: 16px;
      padding: 0 0 0 6px;
      vertical-align: middle;
    }
  }
}
.col-9 {
  .speaker-line {
    .palestrante__img {
      max-width: 40px;
      display: inline-block;
    }
    .palestrante__desc {
      display: inline-block;
      max-width: 290px;
      padding: 0 0 0 6px;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Speaker.vue